import React, { useMemo } from "react";
import StarEmpty from "../../assets/vectors/StarEmpty";
import StarFull from "../../assets/vectors/StarFull";
import StarHalf from "../../assets/vectors/StarHalf";
import { LevelConstants } from "../../constants";

interface MapStarProps {
	level?: any;
	rate?: any;
	width?: any;
	height?: any;
	top?: any;
	color?: any;
	starCount?: any;
	indexer?: any;
	style?: any;
}

// Map the 5 stars, either empty or full
const MapStars = ({
	level,
	rate,
	width,
	height,
	top,
	color,
	starCount,
	indexer = null,
	style = {},
}: MapStarProps): any => {
	const mainkey = indexer ? `${indexer}-starmap` : `${level?._id}-starmap`;
	const featured = level?.status === LevelConstants.Statuses.FEATURED;

	// Decide whether to use the level or the rate
	const mappedStars = useMemo(() => {
		if (level?.rating || rate) {
			let starArray: any[] = [];
			const rating = rate ? parseFloat(rate) : parseFloat(level?.rating);
			// loop over each star possibility
			for (let i = 0; i < starCount; i++) {
				const result = Math.ceil((rating - i)* 2) / 2;

				if (result >= 1) {
					// append a full star
					starArray.push(
						<StarFull
							width={width}
							height={height}
							{...(color && color !== "" && { color })}
							featured={featured}
						/>,
					);
					continue;
				}
				if (result >= 0.5) {
					// if the number behind the comma is smaller or the same as 0.5, apply half a star, otherwise a full star
					starArray.push(
						<StarHalf
							width={width}
							height={height}
							{...(color && color !== "" && { color })}
							featured={featured}
						/>,
					);
					continue;
				}
				// fallback is to add empty star
				starArray.push(<StarEmpty width={width} height={height} />);
				continue;
			}
			return Array.from(
				{ length: Math.ceil(starArray.length / 5) },
				(_, i) => starArray.slice(i * 5, (i + 1) * 5),
			);
		}
	}, [level?.rating, rate, starCount, width, height, color, featured]);

	// If none are present, render nothing
	if (!mappedStars?.length) return null;


	return (
		<div
			style={{
				display: "flex",
				flexWrap: "wrap",
				justifyContent: "center",
				alignItems: "flex-start", // avoid full height alignment
				gap: "5px",
				top: top,				
				...style,
			}}>
			{mappedStars?.map((starRow, key) => (
				<div
					key={`star-row-map-${mainkey}${key}`}
					className="unselectable flex-stars"
					style={{
						display: "flex",
						flexDirection: "row",
						gap: "5px",
						...(starCount === 10 && {
							display: "grid",
							gridTemplateColumns: "repeat(5, 1fr)",
						}),
					}}>
					{starRow?.map((value, index) => (
						<span key={`star-batch-map-${mainkey}${key}${index}${value}`}>
							{value}
						</span>
					))}
				</div>
			))}
		</div>
	);
};

export default MapStars;
